import { render, staticRenderFns } from "./FoodDialog.vue?vue&type=template&id=4ea55608&scoped=true"
import script from "./FoodDialog.vue?vue&type=script&lang=js"
export * from "./FoodDialog.vue?vue&type=script&lang=js"
import style0 from "./FoodDialog.vue?vue&type=style&index=0&id=4ea55608&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ea55608",
  null
  
)

export default component.exports